export const Stores = {
    application: 'application',
    apply: 'apply',
    available: 'available',
    availableAt: 'available_at',
    bookAppointment: 'book_appointment',
    callForAvailability: 'call_for_availability',
    chooseAStore: 'choose_a_store',
    collectInStore: 'collect_in_store',
    complimentaryEngraving: 'complimentary_engraving',
    contactStore: 'contact_store',
    filters: 'filters',
    findInStore: 'find_in_store',
    findStore: 'find_store',
    getDirections: 'get_directions',
    goToDirectoryLabel: 'go_to_directory',
    hours: 'hours',
    inStoreServices: 'in_store_services',
    locations: 'stores_found',
    moveTheMap: 'move_the_map',
    nearby: 'nearby',
    noFilterResultMessage: 'no_filter_result_message',
    notAvailable: 'not_available',
    openNow: 'open_now',
    openTodayUntil: 'open_today_until',
    openUntil: 'open_until',
    otherNearbyLocations: 'other_neraby_locations',
    pickUpInStore: 'pick_up_in_store',
    searchPlaceholder: 'search_placeholder',
    searchThisArea: 'serach_this_area',
    seeAvailability: 'see_availability',
    storeClosed: 'store_closed',
    storeClosingHour: 'store_closing_hour',
    storeDetails: 'store_details',
    storeDetailsMapAlt: 'static_map_alt_text',
    storeLocator: 'store_locator',
    storeOpen: 'store_open',
    storeOpeningHour: 'store_opening_hour',
    stores: 'stores',
    storesFound: 'stores_found',
    storesHome: 'stores_home',
    storesLandingTitle: 'stores_landing_title',
    storesLandingSubtitle: 'stores_landing_subtitle',
    storesDirectoryTitle: 'stores_directory_title',
    storesDirectorySubtitle: 'stores_directory_subtitle',
    storesDirectoryCTA: 'stores_directory_cta',
    storeList: 'store_list',
    today: 'today',
    yourStore: 'your_store',
    pickUpInStoreWantItToday: 'want_it_today',
    pickUpInStoreInformationTitle: 'buy_online_pick_up_in_store',
    pickUpInStoreInformationDescription: 'currently_available_at',
    pickUpInStoreAddItemsToBagTitle: 'add_items_to_bag',
    pickUpInStoreAddItemsToBagDescription: 'find_and_add_to_bag',
    pickUpInStoreCheckoutTitle: 'checkout',
    pickUpInStoreCheckoutDescription: 'click_buy_online_pick_up_in_store_and_select',
    pickUpInStoreNotificationTitle: 'notification_and_pick_up',
    pickUpInStoreNotificationDescription: 'pick_up_in_store_info_third_step_description'
};
